import { render, staticRenderFns } from "./FieldCreate.vue?vue&type=template&id=64a1ff18&"
import script from "./FieldCreate.vue?vue&type=script&lang=js&"
export * from "./FieldCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports